<template>
    <!-- Carrusel de Imagenes -->
    <div id="carouselExampleAutoplaying" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner">
            <div class="carousel-item active">
                <img src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2FBanner_carrera.png?alt=media&token=f3aeed09-3a46-40c9-b28d-4ef24383a878"
                    alt="Banner 1" class="bd-placeholder-img bd-placeholder-img-lg d-block w-100" width="800"
                    height="500">
            </div>
            <div class="carousel-item">
                <img src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2FCOPIAS.png?alt=media&token=25907bdd-b16f-47eb-85d5-3352f6a1d976"
                    alt="Banner 2" class="bd-placeholder-img bd-placeholder-img-lg d-block w-100" width="800"
                    height="500">
            </div>
            <div class="carousel-item">
                <img src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2FCOPIA%202.png?alt=media&token=dc9d012f-6da0-49ed-bed8-9e07ab2c3ba3"
                    alt="Banner 3" class="bd-placeholder-img bd-placeholder-img-lg d-block w-100" width="800"
                    height="500">
            </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying"
            data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying"
            data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
        </button>
    </div>

    <!-- Contenido principal de la página -->
    <main class="container mt-5 text-center">
        <div class="container">
            <div class="row">
                <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12">
                    <div class="card cardInfo">
                        <img class="logoCard img-fluid"
                            src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2Flogo.png?alt=media&token=9e305c42-fcd3-4cd7-9149-3c1adfcdac57"
                            alt="Logo" />

                        <div class="card-body">
                            <h4 class="textTitle">Carrera El Santuario - El Xhidenxi</h4>
                            <h5 class="textSubtitle">Canalejas Jilotepec - Estado de México</h5>

                            <ul class="list-group mt-3">
                                <li class="list-group-item">
                                    <strong class="textBoldBodyCard">Fecha:</strong> <span
                                        class="textRegularBodyCard">Domingo, 18 de junio</span>
                                </li>
                                <li class="list-group-item">
                                    <strong class="textBoldBodyCard">Lugar:</strong> <span
                                        class="textRegularBodyCard">Explanada de la delegación Municipal de
                                        Canalejas.</span>
                                </li>
                                <li class="list-group-item">
                                    <strong class="textBoldBodyCard">Hora de Inicio:</strong> <span
                                        class="textRegularBodyCard">8:00 AM</span>
                                </li>
                                <li class="list-group-item">
                                    <strong class="textBoldBodyCard">Distancias:</strong> <span
                                        class="textRegularBodyCard">12 km, 25 obstáculos.</span>
                                </li>
                            </ul>

                            <a class="btn btn-success mt-2" href="#" aria-disabled="true">
                                Inscripción finalizada
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12">
                    <div class="text-center">
                        <img src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2FLogoPrincipal.png?alt=media&token=7c05bd30-7ab0-475d-83aa-179d4646ac60"
                            alt="LOGO" width="250" height="250">
                    </div>
                    <h1>¡Únete a nuestra carrera de obstáculos!</h1>
                    <p>
                        La carrera se llevará a cabo el próximo <strong>18 de Junio del 2023</strong>.
                        Todos son bienvenidos a participar, ¡no importa su nivel
                        de experiencia!
                        Hay premios para los ganadores de cada categoría.
                    </p>
                </div>
            </div>

            <hr />

            <div class="row">
                <section id="informacion" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="container">
                        <h2>Información</h2>
                        <p>
                            Aquí encontrarás toda la información relevante sobre la carrera
                            de obstáculos.
                        </p>
                    </div>
                </section>

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <img class="img-fluid"
                        src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2FInicioInfo.png?alt=media&token=2a89545b-c3b0-4821-ba5d-a2f31ba39e2e"
                        style="height: 500px; width: 700px;" alt="Informacion">
                </div>
                <hr class="mt-3">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <img class="img-fluid"
                        src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2FInicio.png?alt=media&token=940ecea7-420c-4e29-bd78-cf444ec49f85"
                        style="height: 500px; width: 700px;" alt="horario">
                </div>
                <hr class="mt-3">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <img class="img-fluid"
                        src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2Fcategorias.png?alt=media&token=0c7ef986-e062-4121-b464-a61bbd07c908"
                        style="height: 500px; width: 700px;" alt="categorias">
                </div>
                <hr class="mt-3">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <img class="img-fluid"
                        src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2FPrecios.png?alt=media&token=7a039279-7aab-4b68-ae29-78747c2767fd"
                        style="height: 500px; width: 700px;" alt="precios">
                </div>

                <hr class="mt-3">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <img class="img-fluid"
                        src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2Fcarrera%20KIDS.jpg?alt=media&token=11fdd456-429e-4779-a767-a120b26d915b"
                        style="height: 900px; width: 700px;" alt="Kids">
                </div>

                <hr class="mt-3">
                <section id="informacion" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="container">
                        <h2>Premiación y Playera del Kit</h2>
                        <p>
                            Información sobre las medallas de la carrera de obstáculos y la playera de la carrera.
                        </p>
                    </div>
                </section>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <img class="img-fluid"
                        src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2FMedallas.jpg?alt=media&token=e0087ece-1dca-4a79-9449-ca8f9e621950"
                        style="height: 500px; width: 700px;" alt="Medallas">
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <img class="img-fluid"
                        src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2FPlayeras.jpg?alt=media&token=37abefb4-73cb-42f8-9533-56731112f540"
                        style="height: 500px; width: 700px;" alt="Playeras">
                </div>

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3">
                    <h2>Patrocinadores de la Carrera</h2>
                    <hr>
                    <div class="row">
                        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <img src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Patrocinadores%2Fp1.jpg?alt=media&token=016f20e3-3150-4ba4-b1c9-4d62ee22a479"
                                width="200" height="200" alt="Despensa en Linea" class="img-fluid" />
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <img src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Patrocinadores%2Fp2.jpg?alt=media&token=6f1c10f8-5b88-41ef-aa9e-db155c865196"
                                width="200" height="200" alt="Alquiladora Santa Rita" class="img-fluid" />
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <img src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Patrocinadores%2Fp3.jpg?alt=media&token=4c5689ee-ecd0-42f4-aaa5-efca07cfda86"
                                width="200" height="200" alt="Vidrios y Aluminios, Valera" class="img-fluid" />
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <img src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Patrocinadores%2Fp4.jpg?alt=media&token=797eeb9e-2ddd-4dd6-a574-09deee1267bb"
                                width="200" height="200" alt="Nissi" class="img-fluid" />
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <img src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Patrocinadores%2Fp5.jpg?alt=media&token=3846e40a-8010-4721-a886-4718b6c23492"
                                width="200" height="200" alt="Academia de Porteros" class="img-fluid" />
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <img src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Patrocinadores%2Fp6.jpg?alt=media&token=d8a1959e-b86c-493b-b3e6-b77ceda778f0"
                                width="200" height="200" alt="Recicladora" class="img-fluid" />
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <img src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Patrocinadores%2Fp7.jpg?alt=media&token=065049f0-0763-4082-b971-b2b06d0a49e7"
                                width="200" height="200" alt="Super Castillo I" class="img-fluid" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
    <br>
    <!--Saludos a quien vea esto :)-->
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'

onMounted(() => {
  document.body.style.backgroundColor = '#F6F6F6'
})

onUnmounted(() => {
  document.body.style.backgroundColor = '#F6F1EC'
})
</script>

<style scoped>
body {
    background-color: #F6F6F6;
    margin: 0;
}

#navModified {
    background: #567067;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}

#navModified .nav-link {
    font-family: 'GYMZain', Arial sans-serif;
    font-weight: bold;
    color: white;
    font-size: 22px;
}

.logo {
    display: flex;
    align-items: center;
}

.logo img {
    height: 80px;
    margin-right: 10px;
}

.logo span {
    font-size: 20px;
    font-weight: bold;
    color: white;
    margin-right: 10px;
}

#info ul {
    list-style: none;
    display: flex;
    padding: 0;
    margin: 0;
}

#info ul li {
    margin: 0 15px;
}

#info ul li a {
    color: white;
    text-decoration: none;
    font-size: 16px;
}

/* Estilo para el banner */
.bannerHome {
    background-color: #303030;
    padding: 16px;
}

.bannerHome h4 {
    font-family: 'GYMZain', Arial sans-serif;
    font-weight: normal;
    color: #fff;
    font-size: 2rem;
    margin: 0 0 0 0;
}

.bannerHome h1 {
    font-family: 'GYMZain', Arial sans-serif;
    font-weight: bold;
    font-size: 5rem;
    color: #fff;
}

.bannerHome img {
    margin: 0 auto;
    width: 190px;
    height: 190px;
}

.bannerHome .imgHome1,
.bannerHome .imgHome2 {
    border-radius: 120px;
}

/* Colores de texto */
.colorPrincipal {
    color: #567067;
}

/* Textos de las secciones*/
.sectionsTitle {
    margin-top: 60px;
    font-family: "GYMZain", sans-serif;
    font-size: 33px;
    font-weight: bold;
}

/* Estilo para el card Principal */
.cardInfo {
    border-color: #DDDDDD;
    padding-top: 15px;
    padding-bottom: 15px;
}

.textTitle {
    font-family: "GYMZain", sans-serif;
    font-size: 28px;
    font-weight: bold;
    line-height: 1;
    margin: 0;
}

.textSubtitle {
    font-family: "GYMZain", sans-serif;
    font-size: 20px;
    font-weight: lighter;
    line-height: 1;
    margin: 0;
}

.textRegularBodyCard {
    font-family: "GYMZain", sans-serif;
    font-size: 20px;
    font-weight: lighter;
    margin: 0;
}

.textBoldBodyCard {
    font-family: "GYMZain", sans-serif;
    font-size: 20px;
    font-weight: bold;
    margin: 0;
}

.fillButton {
    background-color: #567067;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 8px 20%;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    text-decoration: none;
    margin-top: 20px;
}

.logoCard {
    margin-top: 15px;
    border-radius: 120px;
    height: 180px;
    width: 180px;
    margin: 0 auto;
    object-fit: cover;
}

.imgBanner {
    margin: 0 auto;
    height: 180px;
    width: 180px;
}

.cardBienvenida {
    padding: 16px;
}

.sectionObstaculos {
    position: relative;
    overflow: visible;
}
.sectionObstaculos .circle {
    width: 70px;
    height: 70px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -35px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
}
.sectionObstaculos .circle .icon img {
    width: 35px;
    height: auto;
}
.list-group li {
    padding: 5px;
}
/* Estilo para el card de precios */
#registro ul {
    list-style: none;
    display: flex;
    padding: 0;
    margin: 0;
}

#registro ul li {
    margin: 0 15px;
}

#registro ul li a {
    color: white;
    text-decoration: none;
    font-size: 16px;
}

.card-fase-header {
    background-color: #567067;
    padding: 10px;
}
.card-fase-title-style {
    font-family: "GYMZain", sans-serif;
    font-size: 26px;
    font-weight: bold;
    color: white;
    margin: 0;
}
.card-fase-subtitle-style {
    font-family: "GYMZain", sans-serif;
    font-size: 20px;
    font-weight: normal;
    color: white;
    margin: 0;
}
.card-fase-subtitle-style2 {
    font-family: "GYMZain", sans-serif;
    font-size: 22px;
    font-weight: bold;
    margin: 0;
}

.full-center {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
  }

.gradient-bg {
    background: linear-gradient(to right, #2e473a, #6b8f89);
    color: white;
    border-radius: 1rem;
    overflow: hidden;
    max-width: 800px;
}

.icon-circle {
    background-color: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.3rem;
}

.feature-text {
    font-size: 0.95rem;
}
</style>
